<!-- 视频列表 -->
<template>
    <div class="content">
        <div class="list">
            <div class="item" v-for="(item,index) in videoList" :key="index">
                <div><img  src="../assets/manure/rb3.png" alt=""></div>
                <p>设备名称：{{ item.name }}</p>
                <p>设备状态：{{ item.status == '0'?'在线':'不在线'}}</p>
                <p>设备位置：{{ item.address }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            videoList:[
                {name:"设备名称1", status:"0", address:"1号大棚区域", imgUrl:"../assets/manure/rb1.png"},
                {name:"设备名称2", status:"0", address:"2号大棚区域", imgUrl:"../assets/manure/rb2.png"},
                {name:"设备名称3", status:"0", address:"3号大棚区域", imgUrl:"../assets/manure/rb3.png"},
                {name:"设备名称4", status:"0", address:"4号大棚区域", imgUrl:"../assets/manure/rb1.png"},
                {name:"设备名称5", status:"0", address:"5号大棚区域", imgUrl:"../assets/manure/rb2.png"},
                {name:"设备名称6", status:"0", address:"6号大棚区域", imgUrl:"../assets/manure/rb3.png"},
                {name:"设备名称7", status:"0", address:"7号大棚区域", imgUrl:"../assets/manure/rb1.png"},
            ]
        }
    },
    created(){

    },
    mounted(){

    },
    methods:{

    }
}
</script>

<style lang="scss" scoped>
.content{
    width: 100%;
    height: 100%;
    background: url("../assets/addressbg.png") no-repeat;
    background-size: 100% 100%;
    padding: 30px 50px 60px ;
    color: #fff;
    .list{
        display: flex;
        flex-wrap: wrap;
        .item{
            margin-right: 50px;
            margin-bottom: 40px;
            img{
                width: 400px;
                height: 280px;
            }
            p{
                line-height: 26px;
                font-size: 24px;
                font-family: SourceHanSansSC-regular;
                margin-bottom: 15px;
            }
        }
    }
}
</style>